import { SwitchTiny } from "@/components"

export const TokenDialogVerifiedToggle: React.FC<{
  checked: boolean
  onCheckedChange: (checked: boolean) => void
}> = ({ checked, onCheckedChange }) => {
  return (
    <SwitchTiny
      checked={checked}
      onCheckedChange={onCheckedChange}
      label="Only verified tokens"
      id="only-verified-tokens"
      labelPosition="right"
    />
  )
}
